import { statusType } from './statusType';
import { veeqoContent } from './veeqo';
import { seCeContent } from './seCe';
import { mcfContent } from './mcf';

export const content = {
  seCe: seCeContent,
  veeqo: veeqoContent,
  mcf: mcfContent,
};

export type ContentType = 'seCe' | 'veeqo' | 'mcf';
